import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgFlashFill = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "m 12.095703,2.3867188 c -0.545624,-0.00188 -1.062891,0.2557035 -1.40039,0.7207031 L 4.0058594,12.326172 c -0.3799996,0.539999 -0.4406247,1.230313 -0.140625,1.820312 0.2999997,0.58 0.8907819,0.951172 1.5507812,0.951172 h 4.7285154 v 5.039063 c 0,0.769999 0.480938,1.420156 1.210938,1.660156 0.18,0.06 0.368828,0.08984 0.548828,0.08984 0.549999,0 1.060391,-0.250704 1.400391,-0.720703 l 6.689453,-9.21875 c 0.379999,-0.54 0.440624,-1.230313 0.140625,-1.820313 -0.29,-0.5799693 -0.888829,-0.9511717 -1.548829,-0.9511717 H 13.855469 V 4.1367187 c 0,-0.7699992 -0.480938,-1.4201564 -1.210938,-1.6601562 -0.1825,-0.06 -0.366953,-0.089219 -0.548828,-0.089844 z",
		fill: "currentColor"
	})
});
export default SvgFlashFill;
